var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4267 3.36065C12.14 3.15398 11.8134 3.00065 11.46 2.91398C11.2267 2.84732 10.9734 2.81398 10.72 2.81398H8.24004C7.85337 2.81398 7.82671 2.77398 7.62004 2.50065L6.68671 1.26065C6.25337 0.687318 5.91337 0.333984 4.82671 0.333984H3.28004C1.65337 0.333984 0.333374 1.65398 0.333374 3.28065V10.7207C0.333374 12.3473 1.65337 13.6673 3.28004 13.6673H10.72C12.3467 13.6673 13.6667 12.3473 13.6667 10.7207V5.76065C13.6667 4.76732 13.18 3.89398 12.4267 3.36065ZM8.55337 9.66732H5.44671C5.18671 9.66732 4.98004 9.46065 4.98004 9.20065C4.98004 8.94732 5.18671 8.73398 5.44671 8.73398H8.54671C8.80004 8.73398 9.01337 8.94732 9.01337 9.20065C9.01337 9.46065 8.80671 9.66732 8.55337 9.66732Z",
    fill: "#6BC0E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.1d69a55416a1226dc2e02d4e2ede81e0.svg";
export { ForwardRef as ReactComponent };